import api from '../utils/api';

// Fetch all assessments
export const getAllAssessments = async (headers) => {
  try {
    const response = await api.get('/api/assessments', headers);
    console.log("assessment", response.data)
    return response.data;
  } catch (error) {
    console.error('Error fetching assessments:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch a specific assessment by ID
export const getAssessmentById = async (id, headers) => {
  try {
    const response = await api.get(`/api/assessments/${id}`, headers);
 
    return response.data;
  } catch (error) {
    console.error(`Error fetching assessment with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Create a new assessment
export const createAssessment = async (assessmentData, headers) => {
  try {
    const response = await api.post('/api/assessments', assessmentData, headers);
    return response.data;
  } catch (error) {
    console.error('Error creating assessment:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Update an existing assessment
export const updateAssessment = async (id, assessmentData, headers) => {
  try {
    const response = await api.put(`/api/assessments/${id}`, assessmentData, headers);
    return response.data;
  } catch (error) {
    console.error(`Error updating assessment with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Delete an assessment
export const deleteAssessment = async (id, headers) => {
  try {
    const response = await api.delete(`/api/assessments/${id}`, headers);
    return response.data;
  } catch (error) {
    console.error(`Error deleting assessment with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};
